/**
 * @file ResumeWorkXPCustomFields.tsx
 *
 * @fileoverview This slot allows querying additional fields
 * in the resume work XP section.
 */

export const ResumeWorkXPCustomFields = (): string => {
  return '';
};
